import PostBaseTemplate from "../PostBaseTemplate";
import TikTokComponent from "./TikTokComponent";

function TikTokWrapper({
  platform,
  url,
  type,
  downloaded_path,
  caption,
  creatorName,
  videoRef,
  muted,
  onManualUnmute,
  onManualMute,
}) {
  return (
    <PostBaseTemplate platform={platform} url={url}>
      <TikTokComponent
        type={type}
        downloaded_path={downloaded_path}
        muted={muted}
        url={url}
        creatorName={creatorName}
        videoRef={videoRef}
        caption={caption}
        onManualMute={onManualMute}
        onManualUnmute={onManualUnmute}
      />
    </PostBaseTemplate>
  );
}

export default TikTokWrapper;
